<template>
  <div>
    <div class="top clearfix">
      <!-- <p style="padding-bottom:10px;">banner封面 (1920px*596px)</p> -->
     <Form  label-position="left" >
        <FormItem label="温馨提示" class="fl mt24" prop="summary">
            <Input v-model="tips" style="width: 600px;height:200px;" type="textarea" placeholder="请输入温馨提示"></Input>
          </FormItem>
          </Form>
    </div>
    <div class="pic_wrap">
     <p style="padding-bottom:10px;">购买协议</p>
      <editor
        ref="editor"
        :value="agreement"
        showUser
        showArticle
        @on-change="handleEditorChange"
        style="width: 1200px;height: 500px;"
      />

      <div class="clearfix">
        <Button type="primary" class="fr" :loading="addLoading" @click="handleUpdate">保存</Button>
      </div>
    </div>
  </div>
</template>

<script>
import * as qiniu from "qiniu-js";
import mixins from "@/mixins/page";
import Editor from "_c/editor";

export default {
  name: "index_banner",
  mixins: [mixins],
  components: {
    Editor
  },
  data() {
    return {
      agreement:'',
      tips:'',
      formData:{},
      content: "",
      modalVisibile: false,
      modalLoading: false,
      addLoading: false,
      posterList: [],
      defaultList: [],
      imgName: "",
      visible: false,
      uploadList: [],
      viewImg: "",
      addDisable: false,
      page_size: 155,
      tableLoading: false,
      imgLoading: false,
      poster: ""
    };
  },
  mounted() {
    this.handleQuery();
  },
  methods: {
    handleCancel() {
      this.modalVisibile = false;
      this.poster = "";
    },
    handleModalSubmit() {},
    handleUpdate() {
      this.addLoading = true;
      this.$api.beans_updateHint({ id: this.id,tips: this.tips, agreement: this.agreement }).then(res => {
        if (res.code === 0) {
          this.$Message.success(res.msg);
          this.tableLoading = false;
          // this.handleCancel();
          // this.handleQuery();
        } else {
          this.$Message.error(res.msg);
        }
        this.addLoading = false;
      });
    },
    handleView(item) {
      this.visible = true;
      this.viewImg = item.url;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },  
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.$refs.editor.setHtml('')
      this.tableLoading = true;
      this.$api
        .beans_getHint({  })
        .then(res => {
          if (res.code === 0) {
            if(res.data){
              this.tips=res.data.tips
              this.agreement=res.data.agreement
              this.$refs.editor.setHtml(res.data.agreement)
              this.id=res.data.id

            }          
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    handleRemovePoster(item) {
      let param = {
        id: item.id
      };
      this.$api.delBanner(param).then(res => {
        if (res.code === 0) {
          this.$Message.success(res.msg);
          this.getTableData();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    handleEditorChange(val) {
      this.agreement = val;
    }
  
  }
};
</script>

<style scoped lang="less">
/deep/textarea.ivu-input{
  height: 200px;
}
.mt18 {
  margin-top: 18px;
}
/deep/.w-e-text-container{
  height: 446px !important;
}
.top {
  padding-bottom: 15px;
}
.demo-upload-list,
.demo-upload-list-wrap {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list-wrap {
  border: none;
  width: 800px;
  height: auto;
  margin: 5px 5px;
  box-shadow: none;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
  display: block;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: flex;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.demo-upload-list-wrap .demo-upload-list-cover {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  /*margin: 0 2px;*/
  display: none;
  align-items: center;
  justify-content: center;
}
.pic_wrap {
  padding-top: 15px;
  position: relative;
}
/deep/ .ivu-upload-drag {
  width: 700px;
  height: 200px;
}
.modal_pic {
  width: 700px;
  height: 200px;
  // height: auto;
  display: block;
}
/deep/ .ivu-icon-ios-camera {
  position: absolute;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
/deep/.ivu-spin-fix{
 width: 700px;
 height: 200px;
 top: 80px;
 left: 50px;
 z-index: 9999;
}
</style>
